import { audio } from '../lib/audio.js';
import { input, type InputHandlers } from './keyboard.js';

const MAX_RADIUS = 55;

export function setupTouchControls(handlers: InputHandlers): void {
  const isTouch = matchMedia('(hover:none)').matches || 'ontouchstart' in window;
  if (isTouch) document.body.classList.add('show-mobile');

  const joy = document.getElementById('joy');
  const joyStick = document.getElementById('joyStick');
  if (!joy || !joyStick) return;

  let joyTouchId: number | null = null;
  let joyCenter = { x: 0, y: 0 };

  joy.addEventListener(
    'touchstart',
    (e: TouchEvent) => {
      audio.unlock();
      const r = joy.getBoundingClientRect();
      joyCenter = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
      joyTouchId = e.changedTouches[0]?.identifier ?? null;
      e.preventDefault();
    },
    { passive: false },
  );

  addEventListener(
    'touchmove',
    (e: TouchEvent) => {
      for (const t of Array.from(e.changedTouches)) {
        if (t.identifier === joyTouchId) {
          let dx = t.clientX - joyCenter.x;
          let dy = t.clientY - joyCenter.y;
          const m = Math.hypot(dx, dy);
          if (m > MAX_RADIUS) {
            dx *= MAX_RADIUS / m;
            dy *= MAX_RADIUS / m;
          }
          joyStick.style.transform = `translate(${dx}px, ${dy}px)`;
          input.joyVec = { x: dx / MAX_RADIUS, y: dy / MAX_RADIUS };
          e.preventDefault();
        }
      }
    },
    { passive: false },
  );

  function endJoy(e: TouchEvent): void {
    for (const t of Array.from(e.changedTouches)) {
      if (t.identifier === joyTouchId) {
        joyTouchId = null;
        input.joyVec = { x: 0, y: 0 };
        joyStick!.style.transform = 'translate(0,0)';
      }
    }
  }
  addEventListener('touchend', endJoy);
  addEventListener('touchcancel', endJoy);

  // Ability buttons
  document.querySelectorAll<HTMLDivElement>('.ab').forEach((b) => {
    const ab = b.dataset['ab'];
    if (!ab) return;
    const trigger = (e: Event) => {
      audio.unlock();
      handlers.onAbility(ab as Parameters<InputHandlers['onAbility']>[0]);
      e.preventDefault();
    };
    b.addEventListener('touchstart', trigger, { passive: false });
    b.addEventListener('mousedown', trigger);
  });
}
